import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import type { FormProps } from 'antd';
import { Button, DatePicker, Drawer, Form, FormInstance, Input, Select, TreeSelect } from "antd";
import { useForm } from 'antd/lib/form/Form';
import { useEffect, useRef, useState } from "react";
import * as IssuedCardsApi from '../../../../api/rank/issuedCardApi';

import * as RankApi from '../../../../api/rank/rankApi';
import * as SelectOptionApi from '../../../../api/selectOptions/selectOptionsApi';


import { useSelector } from "react-redux";
import { buildTreeData, convertGroupValueToTreeV2 } from "../../../../api/unit/unitApi";
import useDebounce from "../../../../hook/useDebounce";
import useLoading from "../../../../hook/useLoading";
import useToast from "../../../../hook/useToast";
import { selectorCategoryCarIds } from "../../../../store/slices/categoryCarSlice";
import { fommatSelectOptionV2, formatDateV2, getEditClass, handleStringToDayJsV4 } from "../../../../until";
import './style.scss';

const { RangePicker } = DatePicker;


type FieldType = {
  personContactId: number
  listCarePolicies: number[]
  username: string;
  phone: string;
  rank: number;
  releaseDate: any;
  expirationDate: any;
};



interface CustomerFilterSearch {
  searchProfession?: string
  searchPersonContact?: string
  searchPolicies?: string
}


export interface InforSelectedCodeCustomer {
  value?: string
  label?: string
  id?: number
  phone?: string
}

interface DrawerProps {
  id: number
  isOpen: boolean
  dataInfoCardCustomer?: IssuedCardsApi.IInfoCardCustomer
  dataRank: IssuedCardsApi.IListRankEdit[]

  confirmDrawerEdit: (isSucces: boolean, errorMesses?: string) => void
  closeDrawer: () => void
}


const DrawerEditCard: React.FC<DrawerProps> = ({
  isOpen,
  dataInfoCardCustomer,
  dataRank,
  id,
  closeDrawer,
  confirmDrawerEdit
}) => {
  const [form] = useForm();
  const inputRef = useRef<FormInstance>(null);
  const popupRef = useRef<HTMLDivElement>(null);


  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)

  const rankId = Form.useWatch('rank', form)
  const selectedPolicies = Form.useWatch('listCarePolicies', form) ?? []

  const pushToast = useToast();
  const pushLoading = useLoading();


  const [selectedRank, setSelectedRank] = useState<number | undefined>(undefined);
  const [policyRows, setPolicyRows] = useState<number[]>([Date.now()]);
  const [benefitOptions, setBenefitOptions] = useState<any[]>([]);
  const [searchFilters, setSearchFilters] = useState<CustomerFilterSearch>();

  const [dataBenefitRank, setDataBenefitRank] = useState<RankApi.IInfoRank>()



  const submitForm = () => {
    if (inputRef.current) {
      inputRef.current.submit();
    }
  };


  const handleChange = (value: number) => {
    setSelectedRank(value);
  };



  const getListCarePolicyBenefitsTree = useDebounce(async () => {
    const result = await SelectOptionApi.getListCarePolicyBenefitsTree(searchFilters?.searchPolicies, rankId)
    if (result?.status) {
      setBenefitOptions(convertGroupValueToTreeV2(result.data))
    }
  }, 500)


  const getInfoRank = async () => {
    if (!rankId) return
    const result = await RankApi.getInfoRank(rankId);
    if (result.status) {

      setDataBenefitRank(result.data);

      const currentPolicies =
        form.getFieldValue("listCarePolicies") ?? [];

      const rankPolicyIds =
        result.data.carePolicies?.map(x => x.id) ?? [];

      const remainPolicies =
        currentPolicies.filter(
          (id: number) => !rankPolicyIds.includes(id)
        );

      form.setFieldValue(
        "listCarePolicies",
        remainPolicies
      );

      setPolicyRows(
        remainPolicies.length
          ? remainPolicies.map(() => Date.now() + Math.random())
          : []
      );


    } else {
      pushToast(result.message, "error", 2000)
    }
  }

  const addPolicyRow = () => {
    setPolicyRows(prev => [...prev, Date.now()]);
  };

  const removePolicyRow = (index: number) => {
    setPolicyRows(prev => prev.filter((_, i) => i !== index));
    const policies: (number | undefined)[] = form.getFieldValue('listCarePolicies') ?? [];
    form.setFieldValue('listCarePolicies', policies.filter((_, i) => i !== index));
  };

  const onFinish: FormProps<FieldType>["onFinish"] = async (values: FieldType) => {


    const groupIdPolicies = [
      ...new Set([
        ...(values.listCarePolicies || []),
        ...(dataBenefitRank?.carePolicies?.map(item => item.id) || []),
      ]),
    ];

    const expirationDateTmp = values.expirationDate ? formatDateV2(values.expirationDate) : undefined
    const releaseDateTmp = values.releaseDate ? formatDateV2(values.releaseDate) : undefined


    const result = await IssuedCardsApi.updateCardIssuance(id, groupIdPolicies, releaseDateTmp, expirationDateTmp, values.rank);
    if (result?.status) {
      confirmDrawerEdit?.(true, result.message)

    } else {
      confirmDrawerEdit?.(false, result.message)
    }
  };
  useEffect(() => {
    if (!rankId) return;
    setDataBenefitRank(undefined)
    getInfoRank();
  }, [rankId]);

  useEffect(() => {
    if (isOpen)
      getListCarePolicyBenefitsTree()
  }, [rankId, searchFilters?.searchPolicies])




  useEffect(() => {
    if (!isOpen) {
      form.resetFields();
      setPolicyRows([]);
      setDataBenefitRank(undefined);
      return;
    }

    if (!dataInfoCardCustomer) return;


    setPolicyRows(
      dataInfoCardCustomer.listCarePoliciesExcludeRank.length > 0
        ? dataInfoCardCustomer.listCarePoliciesExcludeRank.map(() => Date.now() + Math.random())
        : [Date.now()]
    );
    form.setFieldsValue({
      personContactId: dataInfoCardCustomer.infoCustomer.code,
      username: dataInfoCardCustomer.infoCustomer.username,
      phone: dataInfoCardCustomer.infoCustomer.phone,
      releaseDate: handleStringToDayJsV4(dataInfoCardCustomer.infoCustomer.releaseDate),
      expirationDate: handleStringToDayJsV4(dataInfoCardCustomer.infoCustomer.expirationDate),
      rank: dataInfoCardCustomer.infoCustomer.rankId,
      listCarePolicies: dataInfoCardCustomer.listCarePoliciesExcludeRank.map(item => item.id),
    });
  }, [isOpen, dataInfoCardCustomer, form]);

  return (
    <Drawer
      title={<p className="font-medium fw-500 text-344054 py-3 px-6 bg-FCFCFD">Chỉnh sửa phát hành thẻ</p>}
      placement="right"
      rootClassName="custom-drawer"
      closable={false}
      onClose={closeDrawer}
      open={isOpen}
      footer={<div className="py-2 px-6 bg-FCFCFD">
        <button onClick={submitForm} className="border-none bg-096DD9 rounded-2  h-8 w-full text-sm font-regular text-white">Cập nhật</button>
      </div>}
    >
      <div
        ref={popupRef}
        className="filter-setting add-card-issuance"
        id="addcardissuance"
      >
        <div className="title-add-filter">
          <span>Chỉnh sửa phát hành thẻ</span>
        </div>
        <div className="content-filter-setting-add  t-scrollbar">
          {/* <Select
              showSearch
              className="custome-select"
              placeholder="Tìm và chọn khách hàng"
              options={arrayCustomer}
              onChange={(value) => handleSelectCustomer(value)}
              suffixIcon={<SearchOutlined />}
            /> */}
          {/* <Input
            disabled
            value={`${dataInfoCardCustomer?.infoCustomer.code} - ${dataInfoCardCustomer?.infoCustomer.username}`}
          /> */}

          <div className="text-sm  font-medium py-2 text-344054">Thông tin thẻ</div>

          <Form
            ref={inputRef}
            form={form}
            className="form-block"
            initialValues={{ remember: true }}
            onFinish={onFinish}
            autoComplete="off"
            layout="vertical"
          >
            {/* <Form.Item<FieldType>
            label={<span className="">Mã định danh khách hàng<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
            name="iduser"
            rules={[{ required: true, message: 'Vui lòng nhập mã định danh khách hàng!' }]}
          >
            <Input placeholder="Mã định danh khách hàng" />
          </Form.Item> */}

            <div
              className={`${getEditClass(dataInfoCardCustomer?.permissions?.cusName?.view, dataInfoCardCustomer?.permissions?.cusName?.edit)} d-flex flex-column gap-2`}

            >
              <p
                className={`text-sm  font-regular text-344054 d-flex gap-2 align-center`}
              >
                Mã định danh khách hàng :
              </p>
              <Form.Item<FieldType>
                layout='vertical'
                name="personContactId"
              // rules={[{ required: true, message: 'Vui lòng chọn Mã định danh khách hàng' }]}

              >
                <Input
                  className="custom-input-css custom-page-css border px-2"
                  disabled


                />

              </Form.Item>
            </div>

            <Form.Item<FieldType>
              label={<span className="">Tên khách hàng/ Tổ chức<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
              name="username"
              className={`${getEditClass(dataInfoCardCustomer?.permissions?.cusName?.view, dataInfoCardCustomer?.permissions?.cusName?.edit)} `}
              rules={[{ required: true, message: 'Vui lòng nhập tên khách hàng!' }]}
            >
              <Input
                disabled
                placeholder="Tên khách hàng/ Tổ chức"
                className="custom-input-css custom-page-css border  pl-2"
              />
            </Form.Item>

            <Form.Item<FieldType>
              label={<span className="">Điện thoại<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
              name="phone"
              className={`${getEditClass(dataInfoCardCustomer?.permissions?.cusName?.view, dataInfoCardCustomer?.permissions?.cusName?.edit)} `}
              rules={[{ required: true, message: 'Vui lòng nhập số điện thoại!' }]}
            >
              <Input
                disabled
                placeholder="Điện thoại"
                className="custom-input-css custom-page-css border pl-2 "
              />
            </Form.Item>

            <div className="date-row">
              <Form.Item<FieldType>
                label={<span className="">Ngày phát hành<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                name="releaseDate"
                rules={[{ required: true, message: 'Vui lòng chọn ngày phát hành!' }]}
                className={`${getEditClass(dataInfoCardCustomer?.permissions?.releaseDate?.view, dataInfoCardCustomer?.permissions?.releaseDate?.edit)} `}
              >
                <DatePicker
                  placeholder="Ngày phát hành"
                  className="custom-input-date w-full"
                  format={'DD/MM/YYYY'}
                />
              </Form.Item>
              <Form.Item<FieldType>
                label="Ngày hết hạn"
                name="expirationDate"
                className={`${getEditClass(dataInfoCardCustomer?.permissions?.expirationDate?.view, dataInfoCardCustomer?.permissions?.expirationDate?.edit)} `}
              >
                <DatePicker
                  placeholder="Ngày hết hạn"
                  className="custom-input-date w-full"
                  format={'DD/MM/YYYY'}
                />
              </Form.Item>
            </div>

            <Form.Item<FieldType>
              label="Hạng thẻ"
              name="rank"
              className={`${getEditClass(dataInfoCardCustomer?.permissions?.rank?.view, dataInfoCardCustomer?.permissions?.rank?.edit)} `}
            >
              <Select
                className='custom-page-css border rounded overflow-hidden'
                placeholder="Hạng thẻ"
                onChange={handleChange}

                allowClear
                onClear={() => setDataBenefitRank(undefined)}
                // value={selectedRank}
                options={fommatSelectOptionV2(dataRank)}
              />
            </Form.Item>
            <div className="custom-page-css flex flex-col gap-1">
              {dataBenefitRank?.carePolicies?.map(item =>

                <span>{item.title}</span>
              )}
            </div>

            {policyRows.map((rowId, index) => (
              <div key={rowId}
                className={`${getEditClass(dataInfoCardCustomer?.permissions?.carePolicies?.view, dataInfoCardCustomer?.permissions?.carePolicies?.edit)} policy-row`}
              >
                <DeleteOutlined
                  className="policy-delete-icon"
                  onClick={() => removePolicyRow(index)}
                />
                <Form.Item<FieldType>
                  name={['listCarePolicies', index]}
                  className="custom-page-css w-full overflow-hidden"
                  rules={[
                    {
                      validator(_, value) {
                        if (dataBenefitRank && dataBenefitRank?.carePolicies?.length > 0) {
                          return Promise.resolve();
                        }

                        if (value !== undefined && value !== null) {
                          return Promise.resolve();
                        }

                        return Promise.reject(
                          new Error("Vui lòng chọn chính sách CSKH!")
                        );
                      },
                    },
                  ]}
                  style={{ flex: 1, marginBottom: 0 }}
                >
                  {/* <Select
                  className='custom-page-css border rounded overflow-hidden'
                  placeholder="Chọn chính sách CSKH"
                
                  options={benefitOptions}
                /> */}
                  <TreeSelect
                    className='custom-page-css w-full border rounded overflow-hidden text-truncate'
                    showSearch
                    placeholder="Chọn chính sách CSKH"
                    allowClear


                    // value={dataFilterTmp.group}
                    treeDefaultExpandAll={false}
                    treeData={buildTreeData(
                      benefitOptions,
                      selectedPolicies,
                      form.getFieldValue(['listCarePolicies', index])
                    )}
                    filterTreeNode={false}
                    onSearch={(value) => setSearchFilters({ ...searchFilters, searchPolicies: value })}
                    onBlur={() => setSearchFilters({ ...searchFilters, searchPolicies: '' })}
                  // onChange={(e) => setDataFilterTmp({ ...dataFilterTmp, group: e !== undefined ? e : undefined })}
                  // onClear={() => setDataFilterTmp({ ...dataFilterTmp, group: undefined })}
                  />
                </Form.Item>
              </div>
            ))}

            <Button
              type="dashed"
              className={`${getEditClass(dataInfoCardCustomer?.permissions?.carePolicies?.view, dataInfoCardCustomer?.permissions?.carePolicies?.edit)} btn-add-policy`}
              onClick={addPolicyRow}
              icon={<PlusOutlined />}
            >
              Thêm chính sách CSKH
            </Button>
          </Form>
        </div>

        <div className="footer-filter-block">
          <div className="btn-block">
            <Button className="btn btn-primary" onClick={submitForm}>
              <div className="text">
                Phát hành
              </div>
            </Button>
          </div>
        </div>
      </div>
    </Drawer>

  )
}
export default DrawerEditCard
